import { Lang } from 'Roblox';
import angular from 'angular';

const placesList = angular
  .module('placesList', ['robloxApp', 'ui.bootstrap', 'modal', 'thumbnails'])
  .config([
    'languageResourceProvider',
    function(languageResourceProvider) {
      if (Lang.PlacesListResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.PlacesListResources);
      }
    }
  ]);

export default placesList;
